
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AgToAg extends Vue {
  @Prop() readonly highlightLinks!: string;
  @Prop() readonly arrowCategories!: string[];

  get fullOpacity(): boolean {
    return this.highlightLinks === 'none' ||
      this.arrowCategories.includes(this.highlightLinks)
      ? true
      : false;
  }
}
